import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	sign: {
		marginRight: "5px",
	},
	valueInfinite: {
		marginRight: "5px",
		color: theme.palette.colors.darkSlateBlue,
		verticalAlign: "middle",
	},
	value: {
		marginRight: "5px",
		color: theme.palette.colors.darkSlateBlue,
		whiteSpace: "nowrap",
	},
}));

const Comments = ({ type, value, message }) => {
	const classes = useStyles();
	switch (type) {
		case 1:
			return (
				<>
					<span className={classes.sign}>+</span>
					<span className={classNames(["icon24 icon-infinite", classes.valueInfinite])} />
					<span>{message}</span>
				</>
			);
			break;
		case 2:
			return (
				<>
					{value && <span className={classes.value}>{value}</span>}
					{message && <span>{message}</span>}
				</>
			);
			break;
		default:
			return null;
			break;
	}
};

export default Comments;
